import React from "react";
import styles from "./hero.module.scss";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";
import dynamic from "next/dynamic";

const CountdownTimer = dynamic(
  () => import("@unisearch/common/countdown_timer"),
  { ssr: false }
);

export const EventHero = ({ goToBookNow, goToviewLocation, ...props }) => {
  return (
    <section
      className={styles.section_hero}
      style={{
        backgroundImage:
          "url(/assets/images/events/images/usa-admission-day.webp)",
      }}
    >
      <div className={styles.hero_overlay_wrapper}>
        <div className={`container ${styles.hero_content_wrapper}`}>
          <div className={`${styles.hero_content}`}>
            <div className={`${styles.hero_content_left}`}>
              <div className={`${styles.hero_content_left_date}`}>04</div>
              <div
                style={{ width: "70%" }}
                className={`${styles.hero_content_left_line}`}
              ></div>
              <div className={`${styles.hero_content_left_date}`}>Mar</div>
              <div className={`${styles.hero_content_left_line}`}></div>
              <div
                className={`${styles.hero_content_left_date} ${styles.hero_content_left_year}`}
              >
                2023
              </div>
            </div>
            <div className={`${styles.hero_content_right}`}>
              <p>UniSearch Conference on</p>
              <h1>USA Admission Day</h1>
              <div className={`${styles.hero_content_right_building}`}>
                <ReactSVG src={getAssets("assets/icons/office-building.svg")} />
                <p>UniSearch India, Bangalore Office</p>
              </div>
              <div className={`${styles.btn_wrapper}`}>
                <button
                  onClick={goToviewLocation}
                  className="btn btn-white btn-bg"
                >
                  View Location
                </button>
                <button
                  onClick={goToBookNow}
                  className="btn btn-secondary btn-bg"
                >
                  Book Now
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.hero_footer_wrapper}>
          <div className={` ${styles.hero_footer_content_wrapper}`}>
            <div className={`${styles.hero_footer_content}`}>
              <div className={styles.start}>Starting in:</div>
              <CountdownTimer
                customClasses={{
                  root: styles.timer_root,
                  counter_number: styles.counter_number,
                  counter_text: styles.count_text,
                }}
                targetDate={"03/04/2023"}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventHero;
